import { ListingType } from "@redotech/cockroachdb-codegen/tables/product/listing-type";
import { accountIdFormat } from "@redotech/redo-account-id";
import { ProductDetailsSchema } from "@redotech/redo-inventory-common/general-listing/general-listing-variant";
import { ListingsWithStatusSchema } from "@redotech/redo-inventory-common/listing-status";
import { ProductMappingSchema } from "@redotech/redo-inventory-common/listing-types";
import { productIdFormat } from "@redotech/redo-product-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  ImageSchema as ListingImageSchema,
  ProductImagesSchema,
  SelectedImageSchema,
} from "../listing-images/get-available-listing-images";

export const ProductMappingsSchema = z.object({
  shopifyMappings: ProductMappingSchema[ListingType.Shopify],
  redoMarketplaceMappings: ProductMappingSchema[ListingType.RedoMarketplace],
  chatGptMappings: ProductMappingSchema[ListingType.Chatgpt],
  ebayMappings: ProductMappingSchema[ListingType.Ebay],
  googleShoppingMappings: ProductMappingSchema[ListingType.GoogleShopping],
});
export type ProductMappings = z.infer<typeof ProductMappingsSchema>;

// Available images for variant listing selection
const AvailableVariantListingImagesSchema_ = z.object({
  productImages: z.array(ProductImagesSchema),
  productFamilyImages: z.array(ListingImageSchema),
  selectedImages: z.array(SelectedImageSchema).nullable(),
});
export const AvailableVariantListingImagesSchema: z.ZodType<AvailableVariantListingImages> =
  AvailableVariantListingImagesSchema_;
export interface AvailableVariantListingImages extends z.infer<
  typeof AvailableVariantListingImagesSchema_
> {}

export const MergedIntoCanonicalSchema = z.object({
  productId: productIdFormat.schema,
  productTitle: z.string().nullable(),
  productFamilyId: z.string().nullable(),
});

export const getProductDetails = unaryRpc({
  name: "getProductDetails",
  input: z.object({ productId: productIdFormat.schema }),
  output: z.object({
    product: ProductDetailsSchema,
    mappings: ProductMappingsSchema,
    listings: ListingsWithStatusSchema,
    availableListingImages: AvailableVariantListingImagesSchema.nullable(),
    editableByCaller: z.boolean(),
    originAccountId: accountIdFormat.schema,
    originStoreName: z.string().nullable(),
    mergedIntoCanonical: MergedIntoCanonicalSchema.nullable(),
  }),
});
